import { render, staticRenderFns } from "./Day.vue?vue&type=template&id=28d435ab&scoped=true"
import script from "./Day.vue?vue&type=script&lang=js"
export * from "./Day.vue?vue&type=script&lang=js"
import style0 from "@/styles/styled_cell.less?vue&type=style&index=0&id=28d435ab&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d435ab",
  null
  
)

export default component.exports